<template>
    <div class="navpage">
        <div class="pageinner">
          <div class="logo" @click="gotIndex">
            <img src="../../assets/images/phone/logo.png" alt="佛法修证心要">
          </div>
          <div class="web_title">佛法修证心要</div>
          <div class="down_nav" @click="showMenu">
            <img src="../../assets/images/phone/menu.png" alt="菜单">
          </div>
        </div>
        <div class="mode" v-if="show_menu==1" @click="showMenu"></div>
        <div class="menus" :class="{'show':show_menu==1}">
          <ul>
            <router-link  :to="{name:item.name}" tag="li" v-for="(item,index) in menugroup" :key="index" active-class="active">{{item.menutxt}}</router-link>
          </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "navs",
        data() {
            return {
              show_menu:0,
              menugroup:[
                {menutxt:'首页',name:'appindex'},
                {menutxt:'心密影音',name:'appvideo'},
                {menutxt:'心密书库',name:'appbook'},
                {menutxt:'心密图文',name:'appimg'},
                {menutxt:'祖师简介',name:'appintroduce'},
                {menutxt:'公告',name:'appres'},
                {menutxt:'下载专区',name:'appdown'},
                ]
            }
        },
        mounted() {

        },
        methods: {
          showMenu(){
            if(this.show_menu==0){
              this.show_menu=1
            }else{
              this.show_menu=0
            }
            this.$emit('showDownMenu',this.show_menu)
          },
          gotIndex(){
            this.$router.push({name:'appindex'})
          }
        }
    }
</script>

<style scoped lang="scss">
.pageinner{
  width:100%;
  height:1rem;
  background: #c9a168;
  padding:0 0.28rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo{
    img{
      width:0.86rem;
      display: block;
    }
  }
  .web_title{
    font-size:0.32rem;
    color:#fff;
  }
  .down_nav{
    img{
      width:0.46rem;
      display: block;
    }
  }
}
.menus{
  position: fixed;
  top:1rem;
  width:4.28rem;
  height:calc(100% - 1rem);
  background: #c9a168;
  right:-100%;
  z-index:11;
  transition: right 0.5s;
  ul{
    li{
      height:1rem;
      width:100%;
      line-height: 1rem;
      text-align: center;
      box-shadow: 0px -1px 1px #fff inset;
      color:#fff;
      font-size:0.28rem;
    }
  }
}
.menus.show{
  right:0;
}
.mode{
  background: rgba(0,0,0,0.2);
  position: fixed;
  top:1rem;
  bottom:0;
  left:0;
  right:0;
  z-index:10;
}
</style>



// WEBPACK FOOTER //
// src/components/phone/nav.vue